/**
 * Role icons for the landing cards and the login header (inline so the screens have no
 * asset dependency). Kept apart from roleMeta.tsx so that file exports data only.
 */

function iconProps() {
  return {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
}

export function UserIcon() {
  return (
    <svg {...iconProps()} aria-hidden>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-3.3 3.6-6 8-6s8 2.7 8 6" />
    </svg>
  );
}

export function StethoscopeIcon() {
  return (
    <svg {...iconProps()} aria-hidden>
      <path d="M5 3v6a5 5 0 0 0 10 0V3" />
      <path d="M3 3h2M13 3h2" />
      <path d="M10 18a5 5 0 0 0 5 5 4 4 0 0 0 4-4v-3" />
      <circle cx="19" cy="11" r="2" />
    </svg>
  );
}

export function PillIcon() {
  return (
    <svg {...iconProps()} aria-hidden>
      <rect x="3" y="8" width="18" height="8" rx="4" />
      <path d="M12 8v8" />
    </svg>
  );
}

export function ShieldIcon() {
  return (
    <svg {...iconProps()} aria-hidden>
      <path d="M12 3l7 3v5c0 4.4-3 7.7-7 10-4-2.3-7-5.6-7-10V6l7-3z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg {...iconProps()} aria-hidden>
      <path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-7a8 8 0 0 1 8-8h2a8 8 0 0 1 8 4z" />
      <path d="M8 11h6M8 14h4" />
    </svg>
  );
}
